import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/AppLayout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import WorkspacesPage from './pages/WorkspacesPage';
import EpicsPage from './pages/EpicsPage';
import EpicDetailPage from './pages/EpicDetailPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import SprintsPage from './pages/SprintsPage';
import TeamsPage from './pages/TeamsPage';
import SprintBoardPage from './pages/SprintBoardPage';
import LabelsPage from './pages/LabelsPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <WorkspacesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/workspaces/:workspaceId"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<EpicsPage />} />
            <Route path="epics/:epicId" element={<EpicDetailPage />} />
            <Route path="projects/:projectId" element={<ProjectDetailPage />} />
            <Route path="sprints" element={<SprintsPage />} />
            <Route path="sprints/:sprintId/board" element={<SprintBoardPage />} />
            <Route path="teams" element={<TeamsPage />} />
            <Route path="labels" element={<LabelsPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
